<template>
    <div>
        <report-builder-history />
        <transfer-summary-history class="mt-4"/>
    </div>
</template>

<script>
    import ReportBuilderHistory from "@/components/ReportSummaryHistory/ReportBuilderHistory";
    import TransferSummaryHistory from "@/components/ReportSummaryHistory/TransferSummaryHistory";
    import {mapActions} from "vuex";
    //import * as moment from "moment";
    export default {
        name: "ReportSummaryHistory",
        components: {
            ReportBuilderHistory,
            TransferSummaryHistory
        },
        data() {
            return {
                Active_IPADLKVOO: this.$route.params.IdIpadLKVOO




            }
        },
        methods: {
            ...mapActions("reportsummary",["getHistoryBuilderAndTransferSummary"]),

            async getHistoryBuilderandTransferSummariesByIPADLKVOO() {
                try {
                    //let list = await this.$store.dispatch("reportSummary/getReportList") //todayText
                    // alert("")
                    // let STDDay = moment(this.todayText).format('YYYY-MM-DD');
                    let list = await this.getHistoryBuilderAndTransferSummary(this.Active_IPADLKVOO);
                    // alert("")
                    // this.setReportSummaryList(list)
                    console.log(list);
                } catch (e) {
                    //this.$notify({title: "Error", text:"Error on getHistoryBuilderandTransferSummariesByIPADLKVOO, "+ e.message, type: "error"});
                }
            },


        },
        async created() {

            this.Active_IPADLKVOO = this.$route.params.IdIpadLKVOO
            await this.getHistoryBuilderandTransferSummariesByIPADLKVOO();

        },
        computed: {},
        mounted() {},
        watch: {}
    }
</script>
<style>

</style>
